module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "fm_head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rcover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Cover#cover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rtitle"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Titlepage#title"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Dedication#_idParaDest-1"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "rf1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_AUGUST_2018#f1"
    }
  }, [_vm._v("August 2018")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rf2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_TEN_WEEKS_EARLIER#f2"
    }
  }, [_vm._v("Ten Weeks Earlier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_1#_idParaDest-4"
    }
  }, [_vm._v("1. The Ballerina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_2#_idParaDest-6"
    }
  }, [_vm._v("2. Lars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_3#_idParaDest-8"
    }
  }, [_vm._v("3. Miss Santos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_4#_idParaDest-10"
    }
  }, [_vm._v("4. The Puppy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_5#_idParaDest-12"
    }
  }, [_vm._v("5. Honey and Virtue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_6#_idParaDest-14"
    }
  }, [_vm._v("6. Mansfield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_7#_idParaDest-16"
    }
  }, [_vm._v("7. Haley-Anne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_8#_idParaDest-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Rose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_9#_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Blue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_10#_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Henry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_11#_idParaDest-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Senator Halladay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_12#_idParaDest-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. James")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_13#_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Charlie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_14#_idParaDest-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Rory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_15#_idParaDest-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Lucky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_16#_idParaDest-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Bebe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_17#_idParaDest-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Dez")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_18#_idParaDest-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Renata")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_19#_idParaDest-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Kep")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_20#_idParaDest-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. June")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_21#_idParaDest-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Alice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_22#_idParaDest-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Stanton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_23#_idParaDest-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Elgin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_24#_idParaDest-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Detective Monet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_25#_idParaDest-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Good Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_26#_idParaDest-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Constable Lashey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_27#_idParaDest-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Todd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_28#_idParaDest-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Manny")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_29#_idParaDest-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Grease Monkey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_30#_idParaDest-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Annalee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_31#_idParaDest-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Pequeño Policial")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_32#_idParaDest-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Ollie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_33#_idParaDest-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Stu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_34#_idParaDest-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Alison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_35#_idParaDest-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Halladay House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_36#_idParaDest-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Lois Greenaway’s Dance Academy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_37#_idParaDest-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Possum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_38#_idParaDest-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Lana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_39#_idParaDest-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Lois")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_40#_idParaDest-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Edgar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_41#_idParaDest-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Levi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_42#_idParaDest-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. Shannon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_43#_idParaDest-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Mama")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_44#_idParaDest-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. Tommy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_45#_idParaDest-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. Marty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_46#_idParaDest-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. Augusta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Chapter_47#_idParaDest-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. Gracie")])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "r_idParaDest-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Acknowledgments#_idParaDest-98",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "npann"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Poison_Announcement#pann",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Excerpt from")]), _vm._v(" POISON LILIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "nppr1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Poison_Present_Day#ppr1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Present Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "npfi2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Poison_First_Trimester#pfi2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("First Trimester")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "npch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Poison_Chapter_1_Gish#pch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("1: Gish")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "npch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Poison_Chapter_2_Poppy#pch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("2: Poppy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-99",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062948052_Copyright#_idParaDest-100",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-101",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4d4d920","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062948052_Contents.vue
// module id = 66
// module chunks = 0